// import styles from "./Features.module.css";
// import { Link } from "react-router-dom";

// const FeatureItem = ({ feature, index }) => {
//   const isEven = index % 2 !== 0;

//   return (
//     <div
//       className={`${styles.featureExtended} ${
//         isEven ? styles.featureReversed : ""
//       }`}
//     >
//       <div className={styles.featureExtendedImage}>
//         <div className={styles.mockupBg}>
//           <img
//             src={`/images/${feature.imageBg}`}
//             alt={`Feature ${feature.id} illustration`}
//           />
//         </div>
//         <img
//           className={`${styles.deviceMockup} ${styles.isRevealing}`}
//           src={`/images/${feature.image}`}
//           alt={feature.title}
//         />
//       </div>

//       <div className={`${styles.featureExtendedBody} ${styles.isRevealing}`}>
//         <h3 className={styles.featureTitle}>{feature.title}</h3>
//         <p className={styles.featureDescription}>{feature.description}</p>

//         {feature.isVendor && (
//           <a
//             href="https://vendor.ilovesambhal.com/"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="
//     inline-block
//     mt-6
//     px-8
//     py-3
//     bg-[#EB705C]
//     text-white
//     font-medium
//     text-sm
//     rounded-full
//     shadow-md
//     hover:bg-brand-600
//     hover:shadow-lg
//     transition
//     duration-300
//     ease-in-out
//     focus:outline-none
//     focus:ring-2
//     focus:ring-offset-2
//     focus:ring-brand-400
//   "
//           >
//             Join as Vendor
//           </a>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FeatureItem;



import React from "react";
import styles from "./Features.module.css";
import { Link } from "react-router-dom";

const FeatureItem = ({ feature, index }) => {
  const isEven = index % 2 !== 0;

  return (
    <div
      className={`${styles.featureExtended} ${
        isEven ? styles.featureReversed : ""
      }`}
    >
      {/* Image Section */}
      <div className={styles.featureExtendedImage}>
        <div className={styles.mockupBg}>
          {/* Background Image */}
          <img
            src={feature.imageBg} // public/images path
            alt={`Feature ${feature.id} background`}
          />
        </div>
        {/* Main Device / Feature Image */}
        <img
          className={`${styles.deviceMockup} ${styles.isRevealing}`}
          src={feature.image} // public/images path
          alt={`Feature ${feature.id} illustration`}
        />
      </div>

      {/* Text Section */}
      <div className={`${styles.featureExtendedBody} ${styles.isRevealing}`}>
        <h3 className={styles.featureTitle}>{feature.title}</h3>
        <p className={styles.featureDescription}>{feature.description}</p>

        {/* Vendor Button for Vendor Feature */}
        {feature.isVendor && (
          <Link
            to="https://vendor.ilovesambhal.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-4 px-6 py-3 bg-[#EB705C] text-white font-medium text-sm rounded-full shadow-md hover:bg-[#d05b47] hover:shadow-lg transition duration-300"
          >
            {feature.title} {/* Or you can write 'Join as Vendor' */}
          </Link>
        )}
      </div>
    </div>
  );
};

export default FeatureItem;
